import { MenuBuilder } from './MenuBuilder'
import { MobileButtonBuilder } from './MobileButtonBuilder'
import { ResizeObserver } from './ResizeObserver'

(async () => {
	const resizeObserver = new ResizeObserver(1200)

	const menuBuilder = new MenuBuilder(resizeObserver)
	window.menu = await menuBuilder.build('[data-navbar-content]')

	const menuButtonBuilder = new MobileButtonBuilder(window.menu)
	window.menuButton = menuButtonBuilder.build('[data-navbar-button]')

	let menuBackground = document.createElement('div')
	menuBackground.classList.add('menu-background')
	document.body.prepend(menuBackground)

	window.menu.on('move', (e, ratio) => {
		console.log(ratio)
		menuBackground.style.opacity = ratio
	})
	window.menu.on('open', async () => {
		menuBackground.style.pointerEvents = 'auto'
		menuBackground.style.opacity = 1
	})
	window.menu.on('close', () => {
		menuBackground.style.pointerEvents = 'none'
		menuBackground.style.opacity = 0
	})
	menuBackground.addEventListener('click', () => {
		window.menu.close()
	})

	const submenuOpenHandler = submenu => {
		if (!window.menu.isMobile) return false

		const submenuNode = submenu.node.querySelector('.submenu')
		const subitemsNode = submenuNode.children[0]

		submenuNode.style.height = `${subitemsNode.offsetHeight}px`
	}

	const submenuCloseHandler = submenu => {
		if (!window.menu.isMobile) return false

		const submenuNode = submenu.node.querySelector('.submenu')
		submenuNode.style.height = '0px'
	}

	window.menu.submenus.map(submenu => {
		submenu.on('before:open', submenuOpenHandler)
		submenu.on('before:close', submenuCloseHandler)
	})
})()



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/mod_menu/script.js